"use client";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import DeleteAction from "@/components/SocialNetworks/DeleteAction";
import React, {useState} from "react";
import UpdatePosts from "@/components/SocialNetworks/Posts/UpdatePosts";

export default function PostMenuEdit({postId, trainings, activities, activity_id, training_id, content}){
    const [openDelete, setOpenDelete] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    return(
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button>...</button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className={"w-24 mr-10 "}>
                    <DropdownMenuGroup>
                        <DropdownMenuItem onClick={() => setOpenUpdate(true)}>
                            <button className={""}>Modifier</button>
                        </DropdownMenuItem>

                        <DropdownMenuItem  onClick={() => setOpenDelete(true)}>
                            <p className={"text-red-500"}>Supprimer</p>
                        </DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>
            <DeleteAction
                title={"Suppression du post"}
                type={"post"}
                idType={postId}
                content={"Êtes vous sûr de vouloir supprimer votre post ?"}
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
            />

            <UpdatePosts
                id={postId}
                setOpenUpdate={setOpenUpdate}
                content={content}
                openUpdate={openUpdate}
                trainings={trainings}
                activities={activities}
                activityId={activity_id}
                trainingId={training_id}
            />
        </>

    )
}